import { Injectable } from '@angular/core';
import { BaseService } from '@library-shared/base/base.service';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { ApiRecordsReturn } from '@library-shared/models/api-records-return';
import { spAddress_State_List } from '@models/StoredProcs/spAddress_State_List';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class AddressService extends BaseService {
    private apiURL = environment.apiURL + '/api/address'; // URL to web api

    Address_State_List(): Observable<ApiRecordsReturn<spAddress_State_List>> {
        const url = `${this.apiURL}/Address_State_List`;
        return this.http
            .post<ApiRecordsReturn<spAddress_State_List>>(url, {}, this.requestOptions)
            .pipe(catchError((e) => this.handleError(e)));
    }
}
